import React from 'react';

import {
  Filter,
  useWindowSize,
  Box,
  Card,
} from 'vindi-ds-components';

import tokens from 'vindi-ds-tokens';

import useFilterBills from '../hooks/useFilterBills';

import TableCardBills from './table_card';
import TableBills from './table';
import FiltersBills from './filters';
import ModalExport from './modal-export';
import EmptyStateBills from './empty_state';

const ListComponent = ({ bills }) => {
  const { isMobile } = useWindowSize();
  const RootContainer = isMobile ? React.Fragment : Card;
  const Table = isMobile ? TableCardBills : TableBills;

  return (
    <RootContainer noShadow>
      <Table bills={bills} />

      <Box px={2} pb={3} bgcolor={!isMobile && tokens.color.prsm.neutral['000'].value}>
        <Filter.Pagination />
      </Box>
    </RootContainer>
  );
};

const ListBills = () => {
  const {
    listing,
    modalDownloadRef,
    filterFields,
  } = useFilterBills();

  const { isLoading, status, data } = listing.query;

  const handleClickDownload = () => { modalDownloadRef.current.open(); };

  if (isLoading || status === 'idle' || filterFields === null) {
    return null;
  }

  return (
    <Filter.FilterProvider {...listing}>
      <Box mb={5}>
        <FiltersBills
          onClickDownload={handleClickDownload}
          filterFields={filterFields}
        />
      </Box>

      {data.bills?.length ? (
        <ListComponent bills={data.bills} />
      ) : <EmptyStateBills />}

      <ModalExport modalRef={modalDownloadRef} />
    </Filter.FilterProvider>
  );
};

export default ListBills;
